export const USER_SIGN_IN = 'USERS_SIGN_IN';
export const USER_SIGN_OUT = 'USER_SIGN_OUT';
export const USER_GET = 'USER_GET';
export const TEAM_LIST_GET = 'TEAM_LIST_GET';
export const SERVICE_ENTRY_LIST_GET = 'SERVICE_ENTRY_LIST_GET';
export const SERVICE_ENTRY_GET = 'SERVICE_ENTRY_GET';
export const API_DOC_LIST_GET = 'API_DOC_LIST_GET';
export const API_LIST_SEARCH = 'API_LIST_SEARCH';
export const API_DOC_GET = 'API_DOC_GET';
export const API_GET = 'API_GET';